import React, { useState } from 'react';
import { useParams } from 'react-router';

import useGetContractDetailsFromCache from '@/hooks/contract/useGetContractDetailsFromCache.hook';

import EditContractHeadersModal from './components/EditContractHeadersModal';
import OptionButton from '@/components/common/OptionButton/OptionButton';
import EditIcon from '@/components/common/OptionButton/icons/Edit/EditIcon';
import useUpdateContractAdminData from './hooks/useUpdateContractAdminData';
import { UpdateContractAdminDataInputType } from '@/graphql/contracts/_generated_/contracts';

export default function EditContractHeaderContainer() {
  const { contractId }: { contractId: UUID } = useParams();
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const contract = useGetContractDetailsFromCache(contractId);
  
  const { updateContractAdminData } = useUpdateContractAdminData(contractId, true);

  const handleSubmit = (contractData: UpdateContractAdminDataInputType) => {
    updateContractAdminData(contractData)
      .then(data => {
        if (data) setIsOpenEditModal(false);
      });
  };

  return (
    <>
      {isOpenEditModal && contract && (
        <EditContractHeadersModal
          onSubmit={handleSubmit}
          onClose={() => setIsOpenEditModal(false)}
          contract={contract}
        />
      )}

      <OptionButton
        Icon={<EditIcon />}
        onClick={() => setIsOpenEditModal(true)}
      >
        Edit Contract Header
      </OptionButton>
    </>

  );
}
